// import $ from "jquery";

$(document).ready(function () {
  acfExampleBlock();
});

function acfExampleBlock() {}
